// extracted by mini-css-extract-plugin
module.exports = {"wysiwyg_toolbar":"TextEditor_wysiwyg_toolbar__pIKLI","wysiwyg_editor":"TextEditor_wysiwyg_editor__a6tO_"};